module.exports = __webpack_public_path__ + "img/mf.487f7bd7.svg";